import { camelize as e, getCurrentInstance as t } from "vue";
//#region src/composables/useRealProps.ts
function n(t) {
	let n = {};
	for (let r in t) {
		let i = r.includes("-") ? e(r) : r;
		n[i] = t[r];
	}
	return n;
}
function r() {
	return n(t()?.vnode?.props ?? {});
}
//#endregion
export { n as propsToCamelKeyProps, r as useRealProps };

//# sourceMappingURL=useRealProps.js.map